module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticClass: "filterInput",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "emit": _vm.emit,
      "disabled": _vm.disabled,
      "placeholder": "--/--/----"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9524e88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/control/LostYearsDOBDateInput.vue
// module id = 1829
// module chunks = 0